import { ref, onMounted, onUnmounted } from 'vue'

export function useMediaQuery(query: string) {
  const matches = ref(import.meta.client ? window.matchMedia(query).matches : false)

  // The listener has to be removed from the same MediaQueryList it was added
  // to; window.matchMedia() hands back a new object on every call.
  let mediaQuery: MediaQueryList | null = null

  const updateMatches = (event: MediaQueryListEvent) => {
    matches.value = event.matches
  }

  onMounted(() => {
    if (!import.meta.client) return

    mediaQuery = window.matchMedia(query)
    matches.value = mediaQuery.matches
    mediaQuery.addEventListener('change', updateMatches)
  })

  onUnmounted(() => {
    mediaQuery?.removeEventListener('change', updateMatches)
    mediaQuery = null
  })

  return matches
}
